export const formatNumber = (num, decimals = 2) => {
  let [integerPart, decimalPart] = num.toFixed(decimals).split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
};

export function transformObject(obj) {
  if (Array.isArray(obj)) {
    return obj.flatMap(transformObject);
  } else if (obj !== null && typeof obj === "object") {
    const newObj = {};
    for (const key in obj) {
      if (key === "edges" && Array.isArray(obj[key])) {
        return obj[key].flatMap((edge) =>
          transformObject(edge.node)
        );
      } else if (key !== "node" && key !== "__typename") {
        newObj[key] = transformObject(obj[key]);
      }
    }
    return newObj;
  } else {
    return obj;
  }
}
